import type { VFC } from 'react';
import styled from 'styled-components';
import { useSettings } from '@n3/pn-core';

const StyledContainer = styled.div({
  display: 'inline-flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  cursor: 'pointer',
  textDecoration: 'none',
});

const StyledLogo = styled.div({
  width: 48,
});

const StyledContext = styled.div(
  ({
    theme: {
      conditions: { tablet },
    },
  }) => ({
    display: 'none',
    marginLeft: 24,
    paddingBottom: 10,

    [tablet]: {
      display: 'block',
    },
  })
);

const StyledTitle = styled.div({
  font: '18px / 24px "Open Sans Bold", Helvetica, sans-serif',
  fontWeight: 700,
  color: '#2D323A',
});

const StyledDescription = styled.div({
  font: '18px / 24px "Open Sans Bold", Helvetica, sans-serif',
  fontWeight: 700,
  color: '#4a90e2',
});

export const HeaderLogo: VFC = () => {
  const {
    header: { logoDesktop },
  } = useSettings();

  return (
    <StyledContainer>
      <StyledLogo>
        <img src={logoDesktop} alt="" />
      </StyledLogo>

      <StyledContext>
        <StyledTitle>Современное образование</StyledTitle>

        <StyledDescription>Ленинградской области</StyledDescription>
      </StyledContext>
    </StyledContainer>
  );
};
